<template>
    <div class="todo-list">
        <div class="header">
            <h1>待辦清單</h1>
            <span class="view-all" @click="$router.push({name: 'bizTodoListDefault', query:{mode: 'list'}})">查看全部</span>
        </div>
        <tabs>
            <tab name="房源" :selected="true">
                <todo-house :limit="3"></todo-house>
            </tab>
            <tab name="預定">
                <todo-booking :limit="3"></todo-booking>
            </tab>
            <tab name="租約">
                <todo-lease :limit="3"></todo-lease>
            </tab>
            <tab name="委託房客">
                <todo-task :limit="3"></todo-task>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import todoHouse from '@/components/bussiness/personalHome/home/todoList/todoHouse.vue';
import todoBooking from '@/components/bussiness/personalHome/home/todoList/todoBooking.vue';
import todoLease from '@/components/bussiness/personalHome/home/todoList/todoLease.vue';
import todoTask from '@/components/bussiness/personalHome/home/todoList/todoTask.vue';

export default {
    components: {
        Tabs,
        Tab,
        todoBooking,
        todoHouse,
        todoLease,
        todoTask,
    }
}
</script>
<style lang="scss">
    .todo-list{
        width: 700px;
        height: 360px;
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        border-radius: 6px;
        box-sizing: border-box;
        .table-list-body ul li{
            align-items: flex-start;
            cursor: pointer;
        }
        .header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 24px;
            h1{
                font-size: 20px;
            }
            .view-all{
                cursor: pointer;
                color: #ff9275;
            }
        }
        
        .tabs{
            padding: 0 24px;
            margin-bottom: 28px;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/todoList/todoList.vue